import { IEventDefinition } from "@highway/mbs-analytics";

export const appEvents: Record<string, IEventDefinition> = {
    markets_overview_page_exit: {
        description: "Fires when user leaves the Markets Overview page.",
        mappings: {
            mixpanel: "markets_overview_page_exit",
        },
    },
    markets_overview_card_selected: {
        description: "Fires when a market card is selected.",
        mappings: {
            mixpanel: "markets_overview_card_selected",
        },
    },
    markets_overview_filters_clicked: {
        description: "Fires when filters option is clicked.",
        mappings: {
            mixpanel: "markets_overview_filters_clicked",
        },
    },
    markets_overview_draw_clicked: {
        description: "Fires when draw tool is clicked.",
        mappings: {
            mixpanel: "markets_overview_draw_clicked",
        },
    },
    markets_overview_tab_clicked: {
        description: "Fires when Markets Overview tab is clicked.",
        mappings: {
            mixpanel: "markets_overview_tab_clicked",
        },
    },
    markets_overview_treasury_yield_spread_tab_clicked: {
        description: "Fires when Treasury Yield Spread tab is clicked.",
        mappings: {
            mixpanel: "markets_overview_treasury_yield_spread_tab_clicked",
        },
    },
    intraday_chart_draw_click: {
        description: "Fires when the user clicks on the Draw tool.",
        mappings: {
            mixpanel: "intraday_chart_draw_click",
        },
    },
};
